export default __webpack_public_path__ + "static/media/Ekierka-03.06489dd5.svg";